import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import './About.css';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];

  // Achievement stats with images and details
  const achievements = [
    {
      image: '/assets/1.jpg',
      number: language === 'ar' ? '١٠٬٠٠٠+' : '10,000+',
      title: language === 'ar' ? 'مستفيد' : 'Beneficiaries',
      description: language === 'ar' ? 'أشخاص تلقوا المساعدة والدعم' : 'People received assistance and support'
    },
    {
      image: '/assets/2.jpg',
      number: language === 'ar' ? '١٠' : '10',
      title: language === 'ar' ? 'مشاريع' : 'Projects',
      description: language === 'ar' ? 'مشاريع إنسانية وتنموية منفذة' : 'Humanitarian and development projects implemented'
    },
    {
      image: '/assets/1.jpg',
      number: language === 'ar' ? '١٥+' : '15+',
      title: language === 'ar' ? 'شريك' : 'Partners',
      description: language === 'ar' ? 'شراكات استراتيجية فعالة' : 'Effective strategic partnerships'
    },
    {
      image: '/assets/2.jpg',
      number: language === 'ar' ? '٤' : '4',
      title: language === 'ar' ? 'ولايات' : 'States',
      description: language === 'ar' ? 'ولايات سودانية نعمل فيها' : 'Sudanese states we operate in'
    }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-logo-section">
          <img src="/MRRO/w1.png" alt="MRRO Logo" className="about-logo" />
          <h2 className="about-title">{t.aboutTitle}</h2>
        </div>

        {/* Achievement Cards */}
        <div className="achievement-cards-section">
          <div className="achievement-grid">
            {achievements.map((achievement, index) => (
              <div key={index} className="achievement-card">
                <div className="achievement-image-wrapper">
                  <img 
                    src={achievement.image} 
                    alt={achievement.title} 
                    className="achievement-image"
                  />
                  <div className="achievement-overlay" />
                  <div className="achievement-number">{achievement.number}</div>
                </div>
                <div className="achievement-content">
                  <h3 className="achievement-title">{achievement.title}</h3>
                  <p className="achievement-description">{achievement.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="about-content">
          <p>{t.aboutP1}</p>
          <p>{t.aboutP2}</p>
          
          <div className="about-image-container">
            <img src="/assets/1.jpg" alt="MRRO humanitarian work" className="about-image" />
          </div>
          
          <div className="about-highlights">
            <div className="highlight">
              <h3>{t.ourFocus}</h3>
              <ul>
                <li>{t.idps}</li>
                <li>{t.vulnerableCommunities}</li>
                <li>{t.crisisAffected}</li>
              </ul>
            </div>
            <div className="highlight">
              <h3>{t.essentialServices}</h3>
              <ul>
                <li>{t.healthcare}</li>
                <li>{t.safeWater}</li>
                <li>{t.sanitation}</li>
                <li>{t.livelihood}</li>
              </ul>
            </div>
          </div>
          <p>{t.aboutP3}</p>
        </div>
      </div>
    </section>
  );
};

export default About;